module.exports = "https://99designs-start-assets.imgix.net/js/908e621a8d411f3d59afed75685dc101.png";